import { shuffleArray } from 'root/lib/utilityFunctions';
import { GAME_ID, REDUX_ACTIONS, QUESTION_STATUS } from '../../data/constants';

const initialState = {
  selectedIndex: -1,
  choices: [],
  status: null,
};

const inferenceReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return {
        ...state,
        choices: parseInferenceChoicesToChoices(payload.inferenceChoices),
        status: QUESTION_STATUS.IN_PROGRESS,
      };

    case REDUX_ACTIONS.UPDATE_INFERENCE_STATE: {
      const { index, isCorrect, shouldRevealAnswer } = payload;

      const status = isCorrect ? QUESTION_STATUS.COMPLETED : state.status;
      const choices = state.choices.map((item, i) => ({
        ...item,
        isDiscarded: index === i ? !item.isCorrect : item.isDiscarded,
      }));

      return {
        ...state,
        selectedIndex: index,
        choices,
        status: shouldRevealAnswer ? QUESTION_STATUS.REVEALED : status,
      };
    }

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        selectedIndex: -1,
      };

    default:
      return state;
  }
};

export default inferenceReducer;

const parseInferenceChoicesToChoices = inferenceChoices =>
  shuffleArray(inferenceChoices).map((inference, index) =>
    ({
      ...inference,
      index,
      isDiscarded: false,
    }));
